import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const PaymentStatusAuthorized = (props) => {
  const _themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Autorisé</title>
        <path
          d="M5.62192 9.04667V17.9924H2V9.04667H5.62192ZM5.62192 9.04667L10.3281 3.62455C10.7741 3.10816 11.4739 2.88793 12.1429 3.055H12.189C13.404 3.36636 13.95 4.76365 13.2579 5.79644L11.0586 9.05427H15.1881C16.3339 9.05427 17.1874 10.087 16.9644 11.1958L15.8802 16.5647C15.711 17.4001 14.9651 18 14.1038 18H5.62192"
          stroke="#4EAE36"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default PaymentStatusAuthorized;
